import React, { useEffect, useState } from "react";

import Form from "react-bootstrap/Form";
import { Link } from "react-router-dom";
import Select from "react-select";
import { IndexUse } from "./IndexUse";
import { IDS } from "../../../../utils/IDS";
import {
  GetSingle,
  Update,
  Create,
  GetAll,
} from "../../../../features/admin/master/pincode/Slice";
import { useDispatch, useSelector } from "react-redux";
import classNames from "classnames";
import { Controller, useForm } from "react-hook-form";
import {
  getAllCities,
  getAllCountries,
  getAllStates,
} from "../../../../features/admin/common/Slice";
import Successfull_Modal from "../../../common-components/common_Modal/Successfull_Modal/Successfull_Modal";
import Add_section_title from "../../../common-components/add-section-title/Add_section_title";

const Add = ({ id, setId, setShowError, setSuccess, setErr }) => {
  const [modalShow, setModalShow] = React.useState(false);
  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    clearErrors,
    setValue,
    setError,
    getValues,
    control,
    watch,
    formState: { errors },
    reset,
  } = useForm();

  const GetData = async (id) => {
    try {
      const res = await dispatch(GetSingle(id));
      if (res.meta.requestStatus === "fulfilled") {
        reset(res?.payload?.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    if (id !== "") {
      GetData(id);
    }
  }, [id]);

  const onSubmit = async (data) => {
    try {
      const DataToSend = new FormData();
      DataToSend.append("country_id", data?.country_id?.value);
      DataToSend.append("state_id", data?.state_id?.value);
      DataToSend.append("city_id", data?.city_id?.value);
      DataToSend.append("name", data?.name);

      let response;
      if (id) {
        response = await dispatch(Update({ id, data: DataToSend }));
      } else {
        response = await dispatch(Create(DataToSend));
      }
      if (response.meta.requestStatus === "fulfilled") {
        await dispatch(GetAll());
        await setId("");
        setSuccess(true);
        setModalShow(true);
        reset({ name: "", country_id: "", state_id: "", city_id: "" });
        setTimeout(() => {
          setSuccess(false);
          setModalShow(false);
        }, 3000);
      } else if (response.meta?.requestStatus === "rejected") {
        setShowError(response.payload?.response?.data?.errors);
      }

      if (response.payload == 406) {
        await setError("name", {
          type: "manual",
          message: "Pincode Already Exists",
        });
      }
    } catch (error) {
      setErr(true);
      console.error("error in Add city", error);
    }
  };

  const countryList = useSelector((state) => state.common.all_country);
  const stateList = useSelector((state) => state.common.all_states);
  const cityList = useSelector((state) => state.common.all_cities);
  useEffect(() => {
    dispatch(getAllCountries());
  }, [dispatch]);
  return (
    <>
      <Add_section_title
        title={id ? "Edit Pincode" : "Add Pincode "}
        alltotal=""
      />
      <div className="forms_section">
        <Form onSubmit={handleSubmit(onSubmit)}>
          <div className="row">
            <div className="col-lg-6 col-md-6 mb-3">
              <div className="form-group">
                <Form.Label>Country</Form.Label>
                <Controller
                  name="country_id" // name of the field
                  {...register("country_id", {
                    required: "Select Country",
                  })}
                  control={control}
                  render={({ field }) => (
                    <Select
                      styles={{
                        control: (baseStyles) => ({
                          ...baseStyles,
                          borderColor: errors.country_id ? "red" : baseStyles,
                        }),
                      }}
                      {...field}
                      options={countryList}
                      onChange={(selectedOption) => {
                        field.onChange(selectedOption.value);
                        dispatch(getAllStates(selectedOption.value));
                        setValue("country_id", selectedOption);
                        setValue("state_id", null);
                        setValue("city_id", null);
                      }}
                    />
                  )}
                />
                {errors.country_id && (
                  <span className="text-danger">
                    {errors.country_id.message}
                  </span>
                )}
              </div>
            </div>
            <div className="col-lg-6 col-md-6 mb-3">
              <div className="form-group">
                <Form.Label>State</Form.Label>
                <Controller
                  name="state_id" // name of the field
                  {...register("state_id", {
                    required: "Select State",
                  })}
                  control={control}
                  render={({ field }) => (
                    <Select
                      styles={{
                        control: (baseStyles) => ({
                          ...baseStyles,
                          borderColor: errors.state_id ? "red" : baseStyles,
                        }),
                      }}
                      {...field}
                      options={stateList}
                      onChange={(selectedOption) => {
                        field.onChange(selectedOption.value);
                        dispatch(getAllCities(selectedOption.value));
                        setValue("state_id", selectedOption);
                        setValue("city_id", null);
                      }}
                    />
                  )}
                />
                {errors.state_id && (
                  <span className="text-danger">{errors.state_id.message}</span>
                )}
              </div>
            </div>
            <div className="col-lg-6 col-md-6 mb-3">
              <div className="form-group">
                <Form.Label>District</Form.Label>
                <Controller
                  name="city_id" // name of the field
                  {...register("city_id", {
                    required: "Select District",
                  })}
                  control={control}
                  render={({ field }) => (
                    <Select
                      styles={{
                        control: (baseStyles) => ({
                          ...baseStyles,
                          borderColor: errors.city_id ? "red" : baseStyles,
                        }),
                      }}
                      {...field}
                      options={cityList}
                    />
                  )}
                />
                {errors.city_id && (
                  <span className="text-danger">{errors.city_id.message}</span>
                )}
              </div>
            </div>
            <div className="col-lg-6 col-md-6 mb-3">
              <div className="form-group">
                <Form.Label>Pincode</Form.Label>
                <Form.Control
                  type="text"
                  name=""
                  placeholder="Please Enter Pincode"
                  {...register("name", {
                    required: "Please Enter Pincode",
                  })}
                  className={classNames("", {
                    "is-invalid": errors?.name,
                  })}
                  onKeyDown={(e) => {
                    // Allow arrow keys (left, right), backspace, and delete key
                    if (
                      e.key === "ArrowLeft" ||
                      e.key === "ArrowRight" ||
                      e.key === "Backspace" ||
                      e.key === "Delete"
                    ) {
                      return; // Allow the action
                    }

                    // Allow only digits (0-9)
                    if (!/^\d$/.test(e.key)) {
                      e.preventDefault(); // Prevent non-digit input
                    }

                    // Prevent input if length is 6
                    if (
                      e.target.value.length >= 6 &&
                      ![
                        "ArrowLeft",
                        "ArrowRight",
                        "Backspace",
                        "Delete",
                      ].includes(e.key)
                    ) {
                      e.preventDefault(); // Prevent adding more than 6 digits
                    }
                  }}
                />
                {errors.name && (
                  <span className="text-danger">{errors.name?.message}</span>
                )}
              </div>
            </div>
          </div>

          <div className="form_submit_div ">
            <div className="row">
              <div className="col-lg-4 mx-auto mb-3">
                <div className="button_group">
                  <button
                    type="button"
                    className="closebtn theme_bg"
                    onClick={() => {
                      reset({
                        name: "",
                        country_id: "",
                        state_id: "",
                        city_id: "",
                      });
                      setId("");
                    }}
                  >
                    Clear
                  </button>
                  <button
                    type="button"
                    className="addbtn"
                    onClick={handleSubmit(onSubmit)}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Form>
      </div>
      <Successfull_Modal
        message={"Successful"}
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
    </>
  );
};

export default Add;
